import { Children } from 'react';
import { getTagStyles } from './TagStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { TagColor } from './types/color.js';
import { TagVariant } from './types/variant.js';

const Tag = _ref => {
  let {
    variant = TagVariant.FILLED,
    color = TagColor.BLACK,
    uppercase = true,
    children,
    ...rest
  } = _ref;
  const childrenArray = Children.toArray(children);
  const child = childrenArray[0];
  if (!children) {
    throw new Error('The tag component must receive a string child');
  } else if (childrenArray.length > 1) {
    throw new Error(`The tag component only supports one child but you passed ${childrenArray.length}`);
  } else if (typeof child !== 'string') {
    throw new Error(`${child} is of type ${typeof child} but tags can only display strings`);
  }
  return jsx("span", {
    ...rest,
    css: getTagStyles(color, variant, uppercase),
    children: child
  });
};

export { Tag };
//# sourceMappingURL=Tag.js.map
